window.WebglMessageEvent = window.WebglMessageEvent==undefined?{}:window.WebglMessageEvent;
window.setWebglMessage = function(){
  window.WebglMessageEvent.STOP = {funcName:'stop',data:false};

  window.WebglMessageEvent.SHOW_EXTERIOR = {funcName:'showExterior',data:{autoRotate:false,sceneId:1,version:'low',colorId:'blue',marker:[1,2,3,4,5,6],fov:70,staff:false}};
  window.WebglMessageEvent.SHOW_INTERIOR = {funcName:'showInterior',data:{id:1,marker:[1,2,3,4,5]},version:null};
  window.WebglMessageEvent.GET_ITEMS = {funcName:'getItems'};
  window.WebglMessageEvent.ADD_ITEM = {funcName:'addItem',data:{}};
  window.WebglMessageEvent.REMOVE_ITEM = {funcName:'removeItem',data:{}};
  window.WebglMessageEvent.LOAD_PROGESS = {type:'webgl',code:201,data:{progess:0}};
  window.WebglMessageEvent.LOAD_SUCCESS = {type:'webgl',code:202,data:'success'};
  window.WebglMessageEvent.LOAD_MEDIA = {type:'webgl',code:301,data:'/'};
  window.WebglMessageEvent.ADD_ITEMS = {funcName:'addItems',data:{items:[]}};
  window.WebglMessageEvent.SHOW_MARKET = {funcName:'showMarker',data:true};
}
window.setWebglMessage();

